/**
 * SearchField
 */
import clsx from 'clsx';
import React from 'react';
import { Form, Field, Text, Icon, Loader } from 'ui-component-library/base';
export var SearchFieldDropdown = function (_a) {
    var children = _a.children;
    return (React.createElement("ul", { className: "absolute z-50 w-full border-2 border-b-0 rounded-sm searchfield__dropdown border-greySemiLight bg-white" }, children));
};
export var SearchFieldDropdownItem = function (_a) {
    var children = _a.children;
    return (React.createElement("li", { className: "text-p border-b-2 border-greySemiLight leading-5 searchfield__dropdown__item" }, children));
};
/** Searchfield component. */
var SearchField = function (_a) {
    var _b;
    var label = _a.label, submitLabel = _a.submitLabel, onChange = _a.onChange, onSubmit = _a.onSubmit, onFocus = _a.onFocus, onBlur = _a.onBlur, id = _a.id, _c = _a.defaultValue, defaultValue = _c === void 0 ? '' : _c, _d = _a.showSpinner, showSpinner = _d === void 0 ? false : _d, children = _a.children, wrapperRef = _a.wrapperRef, fieldRef = _a.fieldRef, className = _a.className;
    return (React.createElement("div", { ref: wrapperRef, className: clsx(className, 'relative searchfield__wrapper'), "data-cid": "SearchField" },
        React.createElement(Form, { onSubmit: onSubmit, onChange: onChange, initialValues: (_b = {}, _b[id] = defaultValue, _b) },
            React.createElement("label", { className: "sr-only", htmlFor: id }, label),
            React.createElement(Field, { type: "text", id: id, name: id, label: label, "aria-label": label, defaultValue: defaultValue, validation: "false", placeholder: label, onFocus: onFocus, onBlur: onBlur, fieldRef: fieldRef, autoComplete: "off", className: "pl-10" }),
            React.createElement("button", { className: "absolute top-0 left-0 w-auto mt-2 ml-3", type: "submit", "data-cid": "SearchFieldSubmit" },
                React.createElement(Text, { as: "span", styleAs: "screenReader" }, submitLabel),
                React.createElement(Icon, { icon: "search", size: 1.25, "aria-hidden": true, color: "black" }))),
        showSpinner && (React.createElement(Loader, { variant: "mini", className: "absolute top-0 right-0 z-40 mt-2 mr-1 pointer-events-none" })),
        children));
};
export default SearchField;
